const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

const pad = (value) => String(value).padStart(2, "0");

const toDate = (value) => {
  if (value == null || value === "") return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === "string" && DATE_ONLY.test(value.trim())) {
    return new Date(`${value.trim()}T00:00:00.000Z`);
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const isUtcStartOfDay = (date) =>
  date.getUTCHours() === 0 &&
  date.getUTCMinutes() === 0 &&
  date.getUTCSeconds() === 0 &&
  date.getUTCMilliseconds() === 0;

const isUtcEndOfDay = (date) =>
  date.getUTCHours() === 23 &&
  date.getUTCMinutes() === 59 &&
  date.getUTCSeconds() === 59 &&
  date.getUTCMilliseconds() === 999;

const utcCalendarDay = (date) =>
  `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;

const hongKongCalendarDayFromDate = (date) =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Hong_Kong",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);

/**
 * Calendar day a commission Start or End was meant to be.
 * Legacy rows stored UTC midnight or UTC end-of-day, so those instants keep
 * the UTC date. Every other instant uses the Hong Kong calendar day.
 */
export const commissionCalendarDay = (value) => {
  const date = toDate(value);
  if (!date) return null;
  if (isUtcStartOfDay(date) || isUtcEndOfDay(date)) return utcCalendarDay(date);
  return hongKongCalendarDayFromDate(date);
};

/** Local calendar date for a date picker, so the field shows the stored day. */
export const toCommissionDatePickerValue = (value) => {
  const day = commissionCalendarDay(value);
  if (!day) return null;
  const [year, month, date] = day.split("-").map(Number);
  return new Date(year, month - 1, date);
};
